<template>
  <div :class="['modal fade',{'was-validated':validated}]" tabindex="-1" role="dialog">
    <div :class="modalDialogClasses" role="document">
      <div class="modal-content">
        <div class="modal-header" v-if="head">
          <h5 class="modal-title" v-text="title"></h5>
          <slot name="header"></slot>
          <button v-if="closeable" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="$emit('save-changes')">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal',
  props: {
    backdrop: {
      type: Boolean,
      default: true
    },
    keyboard: {
      type: Boolean,
      default: true
    },
    focus: {
      type: Boolean,
      default: true
    },
    show: {
      type: Boolean,
      default: true
    },
    closeable: {
      type: Boolean,
      default: true
    },
    size: String,
    title: {
      type: String,
      default: 'Modal Title'
    },
    centered: {
      type: Boolean,
      default: true
    },
    head: {
      type: Boolean,
      default: true
    },
    body: {
      type: Boolean,
      default: true
    },
    foot: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      validated: false
    }
  },
  computed: {
    modalDialogClasses() {
      var modalDialogClasses = ['modal-dialog']
      if (this.size) modalDialogClasses.push('modal-' + this.size);
      if (this.centered) modalDialogClasses.push('modal-dialog-centered');
      return modalDialogClasses
    }
  },
  methods: {
    showModal() {
      $(this.$el).modal(this.$props)
    },
    hideModal() {
      $(this.$el).modal('hide');
    }
  }
}

</script>
